import { useMemo } from 'react';

export enum FormatType {
  INTEGER = 'integer',
  FLOAT = 'float',
  FLOAT_4 = 'float_4',
}

export enum DataType {
  NUMBER = 'number',
  PERCENTAGE = 'percentage',
  CURRENCY = 'currency',
}

export const integerPercentFormatter = new Intl.NumberFormat('en-US', {
  style: 'percent',
  maximumFractionDigits: 0,
}).format;

export const floatPercentFormatter = new Intl.NumberFormat('en-US', {
  style: 'percent',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
}).format;

const float4PercentFormatter = new Intl.NumberFormat('en-US', {
  style: 'percent',
  minimumFractionDigits: 4,
  maximumFractionDigits: 4,
}).format;

export const useNumberFormatter = (
  currency: string,
): Record<DataType, Record<FormatType, (v: number) => string>> => {
  const formattersMap = useMemo(() => {
    const floatCurrencyFormatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    const float4CurrencyFormatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency,
      minimumFractionDigits: 4,
      maximumFractionDigits: 4,
    });
    const integerCurrencyFormatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency,
      maximumFractionDigits: 0,
    });
    const floatNumberFormatter = new Intl.NumberFormat('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    const float4NumberFormatter = new Intl.NumberFormat('en-US', {
      minimumFractionDigits: 4,
      maximumFractionDigits: 4,
    });

    const integerNumberFormatter = new Intl.NumberFormat('en-US', {
      maximumFractionDigits: 0,
    });

    return {
      [DataType.CURRENCY]: {
        [FormatType.INTEGER]: integerCurrencyFormatter.format,
        [FormatType.FLOAT]: floatCurrencyFormatter.format,
        [FormatType.FLOAT_4]: float4CurrencyFormatter.format,
      },
      [DataType.PERCENTAGE]: {
        [FormatType.INTEGER]: integerPercentFormatter,
        [FormatType.FLOAT]: floatPercentFormatter,
        [FormatType.FLOAT_4]: float4PercentFormatter,
      },
      [DataType.NUMBER]: {
        [FormatType.INTEGER]: integerNumberFormatter.format,
        [FormatType.FLOAT]: floatNumberFormatter.format,
        [FormatType.FLOAT_4]: float4NumberFormatter.format,
      },
    };
  }, [currency]);

  return formattersMap;
};
